import React from 'react';
import { Input, Select, Row, Col, Button, Space } from 'antd';
import { SearchOutlined, ClearOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

/**
 * Reusable SearchFilter Component
 * Provides consistent search and filter UI across all modules
 * 
 * Props:
 *   - searchFields: Array of {key: 'fieldName', label: 'Label', type: 'text'|'select', placeholder: '...'}
 *   - filterFields: Array of {key: 'fieldName', label: 'Label', options: [{value, label}]}
 *   - onSearch: Callback function when search/filter changes
 *   - onReset: Callback function when reset is clicked
 */
const SearchFilter = ({
    searchFields = [],
    filterFields = [],
    onSearch = () => { },
    onReset = () => { }
}) => {
    const { t } = useTranslation();
    const [searchValues, setSearchValues] = React.useState({});
    const [filterValues, setFilterValues] = React.useState({});

    const handleSearchChange = (field, value) => {
        const newSearchValues = { ...searchValues, [field]: value };
        setSearchValues(newSearchValues);
        onSearch({ ...newSearchValues, ...filterValues });
    };

    const handleFilterChange = (field, value) => {
        const newFilterValues = { ...filterValues, [field]: value };
        setFilterValues(newFilterValues);
        onSearch({ ...searchValues, ...newFilterValues });
    };

    const handleReset = () => {
        setSearchValues({});
        setFilterValues({});
        onReset();
    };

    return (
        <div style={{ marginBottom: '20px', padding: '16px', backgroundColor: '#f5f5f5', borderRadius: '4px' }}>
            <Row gutter={[16, 16]}>
                {searchFields.map((field) => (
                    <Col xs={24} sm={12} md={8} lg={6} key={field.key}>
                        <Input
                            placeholder={field.placeholder || t('search') + ' ' + field.label}
                            value={searchValues[field.key] || ''}
                            onChange={(e) => handleSearchChange(field.key, e.target.value)}
                            prefix={<SearchOutlined />}
                            allowClear
                        />
                    </Col>
                ))}

                {filterFields.map((field) => (
                    <Col xs={24} sm={12} md={8} lg={6} key={field.key}>
                        <Select
                            placeholder={field.label}
                            value={filterValues[field.key] || undefined}
                            onChange={(value) => handleFilterChange(field.key, value)}
                            options={field.options}
                            allowClear
                            style={{ width: '100%' }}
                        />
                    </Col>
                ))}

                {(Object.keys(searchValues).length > 0 || Object.keys(filterValues).length > 0) && (
                    <Col xs={24} sm={12} md={8} lg={6}>
                        <Button
                            type="primary"
                            danger
                            icon={<ClearOutlined />}
                            onClick={handleReset}
                            style={{ width: '100%' }}
                        >
                            {t('reset')}
                        </Button>
                    </Col>
                )}
            </Row>
        </div>
    );
};

export default SearchFilter;
